import dayjs from 'dayjs';

export const isWithinTenMinutes = (timestamp: number): boolean => {
  const now = dayjs();
  const timeToCheck = dayjs(timestamp);
  const tenMinutesAgo = now.subtract(10, 'minute');

  return timeToCheck.isAfter(tenMinutesAgo) && timeToCheck.isBefore(now);
};
